import { throwError } from './throwError';

export class CurrencyFormatter {
  symbol;

  #formatter;

  #nativeSymbol;

  constructor(locale, currency) {
    try {
      // попытка создания Intl.NumberFormat с currency не из ISO 4217 выкинет ошибку
      this.#formatter = new Intl.NumberFormat(locale, { style: 'currency', currency });
      this.#nativeSymbol = this.#formatter.formatToParts(0).find((part) => part.type === 'currency')?.value ?? throwError('Не найден текущий символ');

      /**
       * Нативный символ валюты из ISO 4217 --> другой (выдуманный) символ
       */
      const NATIVE_SYMBOL_TO_SYMBOL = {
        XOF: 'FCFA',
      };

      this.symbol = NATIVE_SYMBOL_TO_SYMBOL[this.#nativeSymbol] ?? this.#nativeSymbol;
    } catch (error) {
      // При возникновении ошибки будет использован форматтер USD как общеизвестный
      this.#formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: 'USD' });
      this.#nativeSymbol = this.#formatter.formatToParts(0).find((part) => part.type === 'currency')?.value ?? throwError('Не найден текущий символ');

      /**
       * Валюта не из ISO 4217 --> её (выдуманный) символ
       */
      const CURRENCY_TO_SYMBOL = {
        USDT: '₮',
      };

      this.symbol = CURRENCY_TO_SYMBOL[currency] ?? '?';
    }
  }

  format(value) {
    return this.symbol
      ? this.#formatter.format(value).replace(this.#nativeSymbol, this.symbol)
      : this.#formatter.format(value);
  }
}
